import { render, staticRenderFns } from "./promotion-sidebar-year-dates.vue?vue&type=template&id=97280854&scoped=true"
import script from "./promotion-sidebar-year-dates.vue?vue&type=script&lang=js"
export * from "./promotion-sidebar-year-dates.vue?vue&type=script&lang=js"
import style0 from "./promotion-sidebar-year-dates.vue?vue&type=style&index=0&id=97280854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97280854",
  null
  
)

export default component.exports